import React, {useEffect, useState} from 'react';
import './ResetPasswordPage.css';
import Logo from "../../components/logo/Logo";
import Notification from "../../components/notification/Notification";
import {useNavigate, useSearchParams} from "react-router-dom";
import {getAuthUrl} from "../../utils";

function ResetPage() {
    const [searchParams] = useSearchParams();
    const [isAgent, setIsAgent] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        if (searchParams.get("auth-type") === "agent") {
            setIsAgent(true)
        }
        setRedirectUrl(searchParams.get("redirect_url"));
    }, [setIsAgent, searchParams]);

    const [credentials, setCredentials] = useState({
        password: "",
        confirmPassword: "",
        token: searchParams.get("token"),
    });

    const [showNotification, setShowNotification] = useState(false);
    const [notificationType, setNotificationType] = useState("");
    const [notificationMessage, setNotificationMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setCredentials(prevState => ({
            ...prevState,
            [name]: value
        }));
        console.log(credentials)
    };

    const clearNotification = () => {
        setTimeout(() => {
            setShowNotification(false);
        }, 350);
    }

    const submit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        fetch(getAuthUrl(isAgent) + "/reset", {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                password: credentials.password,
                token: credentials.token
            })
        })
            .then((res) => {
                if (res.status === 200) {
                    setNotificationType("success");
                    setNotificationMessage("Password successfully reset.");
                    setShowNotification(true);
                    setIsLoading(false);
                    navigate("/confirm-reset?redirect_url=" + redirectUrl + (isAgent ? "&auth-type=agent" : ""));
                } else {
                    setNotificationType("error");
                    setNotificationMessage("Une erreur inattendue s'est produite. Veuillez réessayer plus tard. Si le problème persiste, n'hésitez pas à contacter notre support client.");
                    setShowNotification(true);
                    setIsLoading(false);
                }
            })
            .catch((error) => {
                console.error(error);
                setNotificationType("error");
                setNotificationMessage("Une erreur inattendue s'est produite. Veuillez réessayer plus tard. Si le problème persiste, n'hésitez pas à contacter notre support client.");
                setShowNotification(true);
                setIsLoading(false);
            });
    };

    const passwordValidator = (password) => {
        if (password.length >= 8 && password.length < 64 && containsLower(password) && containsUpper(password) && containsNumber(password) && containsSpecial(password)) {
            return true
        }
    }

    const containsLower = (str) => {
        return str.toUpperCase() !== str;
    }

    const containsUpper = (str) => {
        return str.toLowerCase() !== str;
    }

    const containsNumber = (str) => {
        return /\d/.test(str)
    }

    const containsSpecial = (str) => {
        return /[!@#$%^&*_-]/.test(str)
    }

    return <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="cp-bg-gray mt-10 sm:rounded-lg sm:mx-auto sm:w-full sm:max-w-[480px]">
            <div className="bg-white py-4 px-16 m-8 rounded-lg">
                <Logo/>
            </div>
            <h2 className="mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-100">
                Mot de passe oublié
            </h2>

            {showNotification ? <Notification done={clearNotification} type={notificationType}
                                              message={notificationMessage}></Notification> : <></>}

            <div className="pointer-events-none sm:px-6 sm:pb-5 lg:px-8 mt-8">
                <div
                    className="pointer-events-auto flex items-center justify-between gap-x-6 bg-red-500 px-6 py-2.5 sm:rounded-xl sm:py-3 sm:pl-4 sm:pr-3.5">
                    <p className="text-sm/6 text-white">
                        <a href={"/request-reset?redirect_url=" + redirectUrl + (isAgent ? "&auth-type=agent" : "")}>
                            <div className="flex items-center justify-center w-full">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth="1.5"
                                     stroke="currentColor" className="size-24 mr-2">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/>
                                </svg>
                                <p>
                                    <strong className="font-semibold">
                                        Votre mot de passe doit :
                                    </strong>
                                    <ul className="list-disc ml-4 mt-2">
                                        <li>Avoir une longueur comprise entre <strong>8 et 64 caractères</strong>.</li>
                                        <li>Contenir au moins une <strong>lettre minuscule</strong>.</li>
                                        <li>Contenir au moins une <strong>lettre majuscule</strong>.</li>
                                        <li>Contenir au moins un <strong>chiffre</strong>.</li>
                                        <li>Contenir au moins un <strong>caractère spécial</strong> parmi
                                            : <code>!@#$%^&*_-</code>.
                                        </li>
                                    </ul>
                                </p>
                            </div>

                        </a>
                    </p>
                </div>
            </div>

            <div className="px-6 py-12 shadow sm:px-12">
                <form className="space-y-6" action={null} method="POST" onSubmit={submit}>

                    <div>
                        <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-100">
                            Mot de passe <span className="text-orange-600 font-bold text-lg">*</span>
                        </label>
                        <div className="mt-2">
                            <input
                                id="password"
                                name="password"
                                type="password"
                                autoComplete="password"
                                required
                                onChange={handleInputChange}
                                className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            />
                        </div>
                        {
                            credentials.password !== "" && !passwordValidator(credentials.password)
                                ? <p className="text-md text-red-600">Format du mot de passe invalide</p>
                                : <></>
                        }
                    </div>

                    <div>
                        <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-100">
                            Confirmation mot de passe <span className="text-orange-600 font-bold text-lg">*</span>
                        </label>
                        <div className="mt-2">
                            <input
                                id="confirm-password"
                                name="confirmPassword"
                                type="password"
                                autoComplete="confirm-password"
                                required
                                onChange={handleInputChange}
                                className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            />
                            {
                                credentials.password !== "" && credentials.password !== credentials.confirmPassword
                                    ? <p className="text-md text-red-600">Les mots de passe doivent être identiques</p>
                                    : <></>
                            }
                        </div>
                    </div>

                    <div className="pt-8">
                        <button
                            disabled={!(passwordValidator(credentials.password) && credentials.password === credentials.confirmPassword)}
                            type="submit"
                            className="mt-0 flex w-full justify-center rounded-md cp-bg-orange disabled:cp-bg-disabled px-3 py-1.5 text-sm font-semibold leading-6 text-white disabled:cp-text-gray shadow-sm hover:cp-bg-orange-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                            {
                                isLoading
                                    ? <div
                                        className="inline-block h-6 w-6 animate-spin rounded-full border-2 border-solid border-current border-e-transparent text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white mr-2"
                                        role="status">
                                        <span
                                            className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"></span>
                                    </div>
                                    : <>Changer le mot de passe</>
                            }
                        </button>
                        <a href={"/login?redirect_url=" + redirectUrl + (isAgent ? "&auth-type=agent" : "")}
                           className="font-semibold text-gray-100 hover:cp-text-orange text-xs">
                            Retour à la page de connexion
                        </a>
                    </div>
                </form>
            </div>
        </div>
    </div>
}

export default ResetPage;
